import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SearchService } from 'src/app/services/search.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { UiService } from 'src/app/services/ui.service';
import { Location } from '@angular/common';

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {

	httpSubscription: Subscription;
	searchTerm: string = '';
	media: any = [];
	timer: any;
	message: string;
	focusedMedia = 0;
	creatorId: number | null = null;
	creatorDisplayName: string | null = null;

	keyboard: string[] = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's',
		't', 'u', 'v', 'w', 'x', 'y', 'z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
	lastKeyboardFocus: number = 0;

	constructor(private searchService: SearchService,
		private route: ActivatedRoute,
		private app: AppComponent,
		private location: Location
	) {
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe((params: Params) => {
			this.creatorId = params.ctid;
			this.creatorDisplayName = params.creatorName;
			this.searchTerm = params["search"] ?? '';
			if (this.searchTerm?.length > 0) {
				this.onSearchChange();
			}
		})
	}

	ngOnDestroy() {
		this.httpSubscription?.unsubscribe();
	}

	onSearchChange() {
		this.focusedMedia = 0;
		this.message = 'Searching...';
		this.media = null;
		if (this.httpSubscription) {
			this.httpSubscription.unsubscribe();
		}


		clearTimeout(this.timer);
		this.timer = setTimeout(() => {
			this.httpSubscription = this.searchService.search(this.searchTerm, this.creatorId).subscribe(res => {
				// v10 search also returns creator-team rows (no mediaId); the TV search grid only renders media
				this.media = (res || []).filter(x => x.mediaId);
				this.message = null;
				if (this.media.length === 0) {
					this.message = 'No results.';
				} else if (this.media.length > 0) {
					this.media.length > 1 ? this.message = `${this.media.length} results` : this.message = `1 result`;
				}
			});
		}, 500);

		if (this.creatorId) {
			this.searchTerm === '' ? this.location.replaceState(`/search?ctid=${this.creatorId}&creatorName=${this.creatorDisplayName}`) : this.location.replaceState(`/search?search=${this.searchTerm}&ctid=${this.creatorId}&creatorName=${this.creatorDisplayName}`);
			this.app.previousUrl = `/search?search=${this.searchTerm}&ctid=${this.creatorId}&creatorName=${this.creatorDisplayName}`
		} else {
			this.searchTerm === '' ? this.location.replaceState(`/search`) : this.location.replaceState(`/search?search=${this.searchTerm}`);
			this.app.previousUrl = `/search?search=${this.searchTerm}`
		}
	}

	button(char: string) {
		this.searchTerm += char;
		this.onSearchChange();
	}

	delete() {
		this.searchTerm = this.searchTerm.slice(0, -1);
		this.onSearchChange();
	}

	@HostListener('keydown', ['$event'])
	onKeyDown(event: any) {
		let key = event.key;
        if (key === 'Unidentified' && event.keyCode == 197) {
			this.delete();
		}
		if (key === 'Unidentified' && event.keyCode == 198) {
			this.searchTerm += ' ';
			this.onSearchChange();
		}
	}
}
